import { Stack, styled } from '@ltvco/refresh-lib/theme';

export const StyledBillingSectionContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '12px',
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
  flexDirection: 'column',
  gap: '20px',
  padding: '20px',
}));
